import type { MaskOptions } from "maska";

export const iban: MaskOptions = {
  mask: "TR## #### #### #### #### #### ##",
  tokens: {
    "#": {
      pattern: /[0-9]/,
    },
  },
};
export const version: MaskOptions = {
  mask: "#.#.#",
  tokens: {
    "#": {
      pattern: /\d/,
    },
  },
};

export const gsm: MaskOptions = {
  mask: "(0$##) ###-##-##",
  tokens: {
    "#": {
      pattern: /\d/,
    },
    $: {
      pattern: /[1-9]/,
    },
  },
};

export const fullName: MaskOptions = {
  mask: "A",
  tokens: {
    A: { pattern: /[a-zA-ZŞşÇçÖöÜüĞğıİ ]/, repeated: true },
  },
};

export const gsmTR: MaskOptions = {
  mask: "(5##) ###-##-##",
  tokens: {
    "#": {
      pattern: /\d/,
    },
  },
};

export const numericOnly = () => ({
  preProcess: (val: string) => val.replace(/[^0-9,.]/g, ""), // Allow digits and commas only
  postProcess: (val: string) => {
    if (!val) return "";
    return `${val}`;
  },
  mask: "0,99",
  tokens: {
    0: {
      pattern: /\d/,
      multiple: true,
    },
    9: {
      pattern: /\d/,
      optional: true,
    },
  },
});

export const phoneTR: MaskOptions = {
  mask: "(###) ###-##-##",
  tokens: {
    "#": {
      pattern: /\d/,
    },
  },
};

export const hourMask = {
  mask: "0#:1#",
  postProcess: (value: string) => {
    const hourPart = value?.substring(0, 2) || "";
    if (parseInt(hourPart) <= 23) {
      return value;
    } else {
      return value?.substring(0, 1);
    }
  },
  tokens: {
    0: {
      pattern: /[0-2]/,
    },
    1: {
      pattern: /[0-5]/,
    },
  },
};

export const priceMask = (currency: "₺" | "$") => ({
  preProcess: (val: string) => val.replace(/[^0-9,.]/g, ""), // Allow digits and commas only
  postProcess: (val: string) => {
    if (!val) return "";
    return `${val} ${currency}`;
  },
  mask: "0,999",
  tokens: {
    0: {
      pattern: /\d/,
      multiple: true,
    },
    9: {
      pattern: /\d/,
      optional: true,
    },
  },
});

export const parseCurrency = (value: string): number => {
  if (!value) return 0;

  if (typeof value === "number") return value;

  // Remove currency symbols and spaces
  if (value.includes("₺")) {
    const cleanValue = value.replace(/[₺$]/g, "").trim();
    const formattedValue = cleanValue.replace(/\./g, "").replace(",", ".");
    return parseFloat(formattedValue);
  } else if (value.includes("$")) {
    if (!value.includes(".")) {
      const cleanValue = value.replace(/[₺$]/g, "").trim();
      const formattedValue = cleanValue.replace(",", ".");
      return parseFloat(formattedValue);
    }
    const cleanValue = value.replace(/[₺$]/g, "").trim();
    const formattedValue = cleanValue.replace(/\./g, "").replace(",", ".");
    return parseFloat(formattedValue);
  } else {
    const formattedValue = value.replace(/\./g, "").replace(",", ".");
    return parseFloat(formattedValue);
  }
};
